import { AbstractControl } from "@angular/forms";

export function notEmptyValidator(control: AbstractControl): { [key: string]: any } | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;

    return isValid ? null : { 'emptyError': 'emptyError' };
}